import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router';

import { switchLocale } from '../i18n';
import { isLocale, rememberLocale } from '../i18n/config';
import { NotFoundPage } from '../pages/marketing/NotFoundPage';

/**
 * Validates the `:locale` segment and keeps i18next in sync with it on client navigation. The
 * language is remembered for the dashboard, whose paths carry none.
 */
export function LocaleLayout() {
  const { locale } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!isLocale(locale)) return;
    rememberLocale(locale);
    if (i18n.language !== locale) void switchLocale(i18n, locale);
  }, [locale, i18n]);

  return isLocale(locale) ? <Outlet /> : <NotFoundPage />;
}
